import { useContext, useState } from "react";

import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin4Line } from "react-icons/ri";
import { CgUnavailable } from "react-icons/cg";
import { AiOutlineCheckCircle } from "react-icons/ai";

import Swal from "sweetalert2";

import { toast } from "react-hot-toast";
// import ManagementContext from "../../../context/AdminManagement/ManagementContext.jsx";
import ManagementContext from "context/WebInfo/ManagementContext.jsx";
import useAxios from "services/useAxios.tsx";
export default function AdminOperationArticle({
  id,
  status,
  isPost = false,
  ArticleData,
  left = "0",
  top = "20",
}) {
  const { setShowModalArticle, setSelectedArticle, setType, setUpdater } =
    useContext(ManagementContext);
  const { execute: updatePostApi } = useAxios("api/updatepost");
  const { execute: deletePostApi } = useAxios("api/deletepost");

  function updatePost(status, id) {
    //status : 0 active, -1 deactive, -2 delete
    let txt = "";
    if (status == 0) txt = "فعال";
    else if (status == -1) txt = "غیرفعال";
    else if (status == -2) txt = "حذف";
    Swal.fire({
      title: `آیا از ${txt} کردن مقاله اطمینان دارید؟`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "تایید",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        let formdata = new FormData();
        if (status === -2) {
          formdata.append("postId", id);
          deletePostApi(formdata).then((data) => {
            if (data.status == 1) {
              toast.success(` مقاله با موفقیت ${txt} شد.`);
              setUpdater((prev) => !prev);
            } else
              toast.error(
                `متاسفانه مشکلی در فرایند پیش آمده است، لطفا مجدد تلاش کنید.`
              );
          });
        } else {
          formdata.append("conditions", `id/=/${id}`);
          formdata.append("keyvalues", `status,${status}`);

          updatePostApi(formdata).then((data) => {
            if (data.status == 1) {
              toast.success(` مقاله با موفقیت ${txt} شد.`);
              setUpdater((prev) => !prev);
            } else
              toast.error(
                `متاسفانه مشکلی در فرایند پیش آمده است، لطفا مجدد تلاش کنید.`
              );
          });
        }
      }
    });
  }
  return (
    <div
      className={`position-absolute ${
        isPost
          ? "d-flex bottom-0 wd-80 mr-12 rd-8 justify-content-around"
          : "rd-tr-10 rd-br-10"
      } `}
      style={{
        backgroundColor: "tomato",
        left: !isPost && `${left}px`,
        top: !isPost && `${top}px`,
        zIndex: "1",
      }}
    >
      <div
        className={`text-center  px-1 pointer ${isPost ? "pd-y-6" : "py-3"}`}
      >
        <FaRegEdit
          onClick={() => {
            setShowModalArticle(true);
            setSelectedArticle(ArticleData);
            setType("edit");
          }}
          style={{ width: 17, height: 17 }}
          color="white"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="ویرایش"
        />
      </div>
      <div
        className={`text-center  px-1 pointer ${isPost ? "pd-y-6" : "py-3"}`}
        onClick={() => updatePost(-2, id)}
      >
        <RiDeleteBin4Line
          style={{ width: 18, height: 18 }}
          color="white"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="حذف"
        />
      </div>
      {status == 0 && (
        <div
          className={`text-center  px-1 pointer ${isPost ? "pd-y-6" : "py-3"}`}
          onClick={() => updatePost(-1, id)}
        >
          <CgUnavailable
            style={{ width: 18, height: 18 }}
            color="white"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="غیرفعال"
          />
        </div>
      )}
      {status == -1 && (
        <div
          className={`text-center  px-1 pointer ${isPost ? "pd-y-6" : "py-3"}`}
          onClick={() => updatePost(0, id)}
        >
          <AiOutlineCheckCircle
            style={{ width: 18, height: 18 }}
            color="white"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="فعال"
          />
        </div>
      )}
    </div>
  );
}
